import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CountryAccessesSelectQuery } from "../graphql/queries";
import type {
  CountryAccessesSelectQueryType,
  CountryAccessesSelectQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useCountryAccessesSelectQuery = (
  options?: QueryHookOptions<
    CountryAccessesSelectQueryType,
    CountryAccessesSelectQueryVariablesType
  >
) => {
  return useQuery<
    CountryAccessesSelectQueryType,
    CountryAccessesSelectQueryVariablesType
  >(CountryAccessesSelectQuery, options);
};
